import { Navigate, Route, Routes } from 'react-router-dom';

import Play from 'pages/Play';
import Start from 'pages/Start';
import Signup from 'pages/Signup';
import PointsEarned from 'pages/PointsEarned';
import EarnMorePoints from 'pages/EarnMorePoints';
import MyAssetStatus from 'pages/MyAssetStatus';
import Profile from 'pages/Profile';
import Tutorial from 'pages/Tutorial';
import DefaultLayout from 'layouts/DefaultLayout';
import useUserStore from 'store/user';
import { useAudioStore } from 'store/sound';
import { useEffect } from 'react';
import Spotlight from './pages/Spotlight';

function App() {
  // store
  const { isLogin } = useUserStore();
  const { createAudio } = useAudioStore();

  useEffect(() => {
    createAudio('/sounds/background.mp3');
  }, [createAudio]);
  return (
    <Routes>
      <Route path="/" element={<Start />} />
      <Route path="/start" element={<Start />} />
      <Route path="/signup" element={<Signup />} />
      <Route path="/tutorial" element={<Tutorial />} />
      <Route element={<DefaultLayout />}>
        <Route path="/play" element={<Play />} />
        <Route path="/points-earned" element={<PointsEarned />} />
        <Route path="/earn-more-points" element={<EarnMorePoints />} />
        <Route path="/my-asset-status" element={<MyAssetStatus />} />
        <Route path="/profile" element={<Profile />} />
        <Route path="/spotlight" element={<Spotlight />} />
      </Route>
      <Route path="*" element={<Navigate to={isLogin ? '/play' : '/start'} replace />} />
    </Routes>
  );
}

export default App;
